import type { GeoImage, Stored } from "@overmap-ai/common"
import { Mention } from "@tiptap/extension-mention"
import { mergeAttributes, ReactNodeViewRenderer } from "@tiptap/react"

import type { MentionOptions } from "../typings"
import { GeoImageMentionComponent } from "./Component"
import { suggestion } from "./suggestion"

export const GeoImageMention = Mention.extend<MentionOptions<Stored<GeoImage>>>({
	name: "GeoImageMention",
	atom: true,
	addAttributes() {
		return {
			uuid: {
				default: null,
			},
		}
	},
	parseHTML() {
		return [
			{
				tag: "geo-image-mention",
			},
		]
	},
	renderHTML({ HTMLAttributes }) {
		return ["geo-image-mention", mergeAttributes(HTMLAttributes)]
	},
	addNodeView() {
		return ReactNodeViewRenderer(GeoImageMentionComponent)
	},
}).configure({
	suggestion,
})
